import React, { Component } from 'react';
import '../styles/LandingPageEmployers.css';

import {
	// Card,
	Typography
} from 'material-ui';

import {
	Accent,
	bgWhite,
	Primary,
	// PurpleShadow
	Title
} from '../helper/consts';

const style = {
	infoSection: {
		maxWidth: '1180px',
		width: '100%',
		paddingTop: '100px',
		padding: '100px auto',
		height: 'min-content',
		minHeight: 'min-content',
		backgroundColor: bgWhite,
		display: 'flex',
		margin: '0px auto 100px'
	},
	accent: {
		color: Accent
	},
	infoTitle: {
		textAlign: 'right',
		margin: '10px 10px 20px',
		color: Accent,
		fontWeight: '800'
	},
	aboutTitle: {
		textAlign: 'center',
		margin: '10px 10px 20px',
		fontWeight: '400',
		color: Primary,
		fontSize: '1.3rem'
	}
};

export default class LandingPageAbout extends Component {
	constructor() {
		super();

		this.state = {
			expanded: false
		};
	}

	handleChange = panel => (event, expanded) => {
		this.setState({
			expanded: expanded ? panel : false
		});
	};

	render() {
		return (
			<section id="employers" style={style.infoSection} className="body">
				<Typography style={style.infoTitle} type={'display1'}>
					<span id="titleBrandMark">{Title}</span>
				</Typography>
				<Typography
					className="cardWidth"
					style={style.aboutTitle}
					type={'subheading'}
				>
					"It's not <span style={style.accent}>what you know</span>, it's{' '}
					<span style={style.accent}>who you know</span>"
				</Typography>
				<Typography
					className="cardWidth"
					style={style.aboutTitle}
					type={'subheading'}
				>
					This timeless adage certainly rings true when it comes to hiring top
					talent and <span id="titleBrandMark">{Title}</span> is connecting
					employers with networkers beyond just their employees to find top
					talent.
				</Typography>
				<Typography
					className="cardWidth"
					style={style.aboutTitle}
					type={'subheading'}
				>
					<span id="titleBrandMark">{Title}</span> is an employee referral
					program on steroids!
				</Typography>
				<Typography
					className="cardWidth"
					style={style.aboutTitle}
					type={'subheading'}
				>
					<span id="titleBrandMark">{Title}</span> provides an unique platform
					to leverage more networkers than just a company’s staff. It engages
					talented networkers that can be second, third, forth, etc. degrees of
					separation from their employees to refer top talent.
				</Typography>
				<Typography
					className="cardWidth"
					style={style.aboutTitle}
					type={'subheading'}
				>
					The draw for the networker? A split of the referral bonus!
				</Typography>
				<Typography
					className="cardWidth"
					style={style.aboutTitle}
					type={'subheading'}
				>
					Finally, it pays to know great people!
				</Typography>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/LandingPageAbout.js